<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <div [innerHTML]="safeHtml" class="prose max-w-none"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Zavřít</button>
</mat-dialog-actions>
